/**
 * @file removes the page loader
 *
 *
 * @author Torbjørn Høvde
 *
 */

export default {
  methods: {
    $_addPageLoader () {
      this.$nextTick(() => {
        document.querySelector('body').classList.add('loading-site');
      });
    },
    $_removePageLoader () {
      this.$nextTick(() => {
        document.querySelector('body').classList.remove('loading-site');
      });
    }
  }
};
